import { S125gS125m01Component } from './s125g-s125m01.component';

export { S125gModule } from './s125g.module';

export const S125gSubComponentsMap = {
	
};

export const S125gComponentsMap = {
	"s125g-s125m01": S125gS125m01Component
};

export const S125gComponents = [
	S125gS125m01Component
];

